export default __webpack_public_path__ + "static/media/slider-info-right-dark-1.aefba9da.png";